module.exports = require("../dist/web");